/**
 * StatCard — reusable stat display component for resume templates.
 *
 * Renders a single stat (label / value / unit) with an optional accent-coloured
 * top border. Used by all four templates so the stat look-and-feel is consistent.
 */
export class StatCard {
  /**
   * @param {Object} opts
   * @param {string}  opts.label        – e.g. "TOTAL MILEAGE"
   * @param {string}  opts.value        – e.g. "2,482"
   * @param {string}  opts.unit         – e.g. "KM / ANNUAL"
   * @param {string} [opts.accentColor] – CSS colour for the top border gradient
   * @returns {HTMLElement}
   */
  static render({ label, value, unit, accentColor = 'var(--cyan)' }) {
    const card = document.createElement('div');
    card.className = 'stat-card';
    card.style.setProperty('--stat-accent', accentColor);

    card.innerHTML = `
      <div class="stat-card__border"></div>
      <span class="stat-card__label">${label}</span>
      <span class="stat-card__value">${value}</span>
      <span class="stat-card__unit">${unit}</span>
    `;

    return card;
  }
}
